import * as types from './subscription.types';

const hasSavedBillingInfo = (billingInfo: types.IBillingInfo | null): boolean => {
  if (!billingInfo) {
    return false;
  }

  return Boolean(
    billingInfo.address && billingInfo.city && billingInfo.state && billingInfo.zipCode && billingInfo.country,
  );
};

export const subscriptionPageSelectors: types.ISubscriptionPageSelectors = {
  selectSetupSession: (state) => state.page.subscription.setupSession,
  selectBillingInfo: (state) => state.page.subscription.billingInfo,
  selectHasBillingInfo: (state) => hasSavedBillingInfo(state.page.subscription.billingInfo),
};
